import * as React from 'react';
import { useIntl } from 'react-intl';
import { ITripsOverViewRecord } from '../interfaces';
import { IS_GPS_RIDE, IS_MANUAL_RIDE } from '../constants';

interface ISourceProps {
  datacyIndex: number;
  data: ITripsOverViewRecord;
}

function SourceCell(props: ISourceProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  const getRideSourceType = () => {
    const type = props.data.source;
    if (type === IS_MANUAL_RIDE) {
      return f({ id: 'tripsOverview.table.newRide.manual' });
    }
    if (type === IS_GPS_RIDE) {
      return f({ id: 'tripsOverview.table.newRide.gps' });
    }
    return f({ id: 'tripsOverview.table.newRide.imported' });
  };

  return (
    <div id="element-width-source" className="align-middle" style={{ minWidth: '100px', flex: 1 }}>
      <div data-cy={`row-${props.datacyIndex + 1}-source`}>
        <div>{getRideSourceType()}</div>
      </div>
    </div>
  );
}

export default React.memo(SourceCell);
